<template>
    <div class="ur-data-grid__content ur-data-grid__content--infinity" :style="contStyle" ref="content"
            @touchstart.prevent="()=>{}" @touchend.prevent="()=>{}">
        <div class="ur-data-grid__content__freeze-wrapper" :style="freezeStyle" ref="freezeWrapper"
                v-if="!!freezeWidth" @wheel="onWheelFixed">
            <div class="ur-data-grid__content__freeze-holder" :style="holdStyle" ref="freezeHolder">
                <freeze-row v-for="(r,i) in rows" :row="r" :idx="i+cStart" :key="i" ref="refFrzs"/>
            </div>
        </div>
        <div class="ur-data-grid__content__scroll-wrapper" :style="scrollStyle" ref="scrollWrapper"
                @scroll="contScroll" @wheel="onWheelFixed">
            <div class="ur-data-grid__content__scorll-holder" :style="holdStyle" ref="scrollHolder">
                <template v-for="(r,i) in rows" >
                    <cont-row  :row="r" :idx="i+cStart" :key="i" ref="refRows"/>
                    <accrd-row :row="r" :key="'acc_'+i" v-if="r.__accordion && !isVertAcc"/>
                </template>
            </div>
        </div>
        <c-select :height="contentHeight" v-if="gridInfo.opts.cellMode"/>
        <!-- Vertical accordion -->
        <accrd-row :row="gridInfo.vars_accordionRow" vertical v-if="gridInfo.vars_accordionRow && isVertAcc"/>
        <!-- Pseudo scroll, please check also 'WrapperMixin' -->
        <p-scroll @on-scroll="onPseudoScroll" ref="pScroll" @adjust-scroll="setScrollLeft"/>
        <!-- anchro for tooltip -->
        <t-anchor :height="cAllHeight"/>
    </div>
</template>

<script>
//[IMPORT] Child components
import contRow       from '../row/urDataGridContentRow.vue';
import freezeRow     from '../row/urDataGridContentFreezeRow.vue';
import accrdRow      from '../row/urDataGridContentAccordionRow.js';
//[IMPORT] Sub components
import pScroll from './sub/urDataGridContentPseudoScroll.vue';
import cSelect from './sub/urDataGridContentCellSelect.vue';
import tAnchor from './sub/urDataGridContentTooltipAnchor.vue';
//[IMPORT] Util mixin
import wrapperMixin from './mixin/urDataGridContentWrapperMixin';
import {copyObj} from '../../util'
export default {
    name : "urDataGridContentInfinity",
    inject : ['gridInfo'],
    mixins : [wrapperMixin],
    components : {contRow, freezeRow, accrdRow, pScroll, cSelect, tAnchor},
    data() {return {
        rows : [],
        vScrollTop : 0,
        vDirection : 'D',
    }},
    computed : {
        // [COMPUTED][VARS] Delta values
        cIndex()     {return ~~(this.vScrollTop/this.rowHeight)}, // 스크롤인데, 음수 체크 필요? 양수로 가정함
        cKeeps()     {return this.windowRow << 1},
        cAllHeight() {return this.totalCount * this.rowHeight},
        cLastStart() {return Math.max(this.totalCount - this.cKeeps, 0)},
        cStart(ag) {
            var st = this.cIndex;
            st += this.vDirection === 'U' ? 1-this.windowRow : 0;
            st = Math.max(0, st);
            return Math.min(st, this.cLastStart) 
        },
        cEnd() {
            return Math.min(this.totalCount, this.cStart + this.cKeeps)
        },
        cPadTop() {return this.rowHeight*this.cStart},
        cPadBot() {return Math.max(0,this.cAllHeight - this.cPadTop - this.rowHeight*this.cKeeps)},
        // [COMPUTED][VARS] Variables
        totalCount()  {return this.gridInfo.vars_viewSize},
        windowRow()   {return this.gridInfo.vars_windowRow},

        freezeWidth() {
            this.$nextTick(()=>{
                // freeze 보이기 여부에 따라 freezeWrapper를 다시 설정해주어야만 scroll이 먹음.
                // 안 할 경우 div의 부모가 없어 scroolTop 을 줘도 먹지가 않음
                this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
            })
            return this.gridInfo.vars_freezeWidth
        },
        rowHeight()   {return this.gridInfo.opts.rowHeight},
        // [COMPUTED][STYLE] Style of scroller
        scrollStyle() {return{
            'width'         :`calc(100% - ${this.freezeWidth}px)`,
            'margin-left'   :`${this.freezeWidth}px`,
        }},
        contentHeight() { // WARNING -> 다른 옵션들 들어가면 이게 틀릴수 있음
            return this.cAllHeight
        },
        holdStyle()  {return{
            'padding-top'   :`${this.cPadTop}px`,
            'padding-bottom':`${this.cPadBot}px`
        }},
        // [COMPUTED][STYLE] Style of Freezer
        freezeStyle() {return{
            'width'         :`${this.freezeWidth}px`,
        }},
        isVertAcc() {return this.gridInfo.vars_accordionVert},
    },
    // use changeProp to identify the prop change.
    watch: {
        vScrollTop(v,w) {
            this.vDirection = v > w ? 'D' : 'U';
            this.buildRows()
        },
        "gridInfo.updated": function() {this.buildRows()},
        // "gridInfo.vars_viewSize": function() {this.setScrollTop(0)},
    },
    created() {
        this.buildRows();/*이 위치가 진짜 맞음?*/
    },
    beforeUpdate(){},
    mounted() {
        this.gridInfo.func.setRefs('content'      ,this.$refs.content);
        this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
        this.gridInfo.func.setRefs('freezeHolder' ,this.$refs.freezeHolder);
        this.gridInfo.func.setRefs('scrollWrapper',this.$refs.scrollWrapper);
        this.gridInfo.func.setRefs('scrollHolder' ,this.$refs.scrollHolder);
    },
    methods: {
        // [METHODS] Update rows : slice(st,ed).map(r=>clone()).forEach(r=>{do something...})
        buildRows() {
            // 1. reset previous
            this.rows.forEach(r =>  {
                var w = this.gridInfo.dataSet.getRow(r.__id)
                if(!w) return;
                w.__compo = null;
            });
            this.rows = [];
            for(var i=~~this.cStart, ii=~~this.cEnd ; i<ii ; i++ ) {
                var r = this.gridInfo.data[i];
                if(!r) continue;
                r.__hover = false;
                var clone = copyObj(r);
                r.__compo = clone;
                this.rows.push(clone);
            }
        },
        getScrollOffset() {
            let wrapper = this.$refs.scrollWrapper;
            if(!wrapper) return 0;
            let holder  = this.$refs.scrollHolder;
            const scrollRect = wrapper.getBoundingClientRect()
            const elemRect   = holder.getBoundingClientRect()
            return scrollRect.top - elemRect.top
        },
        // [METHODS] Scroll control
        contScroll(event) {
            // 1. Calc scrollTop(n direction)
            // 1.1 get offset
            var offset = this.getScrollOffset();
            // 1.2 check render or not
            var isUpdate = this.checkUpdate(offset);
            // 1.3 set offset & maybe redraw grid
            if(isUpdate) {
                this.vScrollTop = offset;
            }
        },
        checkUpdate(offset) {
            // Many things is same as computed logic
            var idx = ~~(offset/this.rowHeight),
                wRow = this.windowRow;
            //var isUp = offset < this.vScrollTop;
            //if(isUp) idx += 1-wRow;
            idx = Math.max(0, idx);
            if(this.cStart <= idx && idx < this.cStart+wRow) {
                return false;
            }
            return true
        }
    },
}
</script>